import { useEffect, useState } from "react";

import { useTranslation } from "@/core/i18n";

import { PersonalisationHeading } from "./PersonalisationHeading";
import { PersonalisationScreenLayout } from "./PersonalisationScreenLayout";

interface PreparingScreenProps {
  durationMs: number;
  userFirstName?: string | null;
}

export const PreparingScreen = ({ durationMs, userFirstName }: PreparingScreenProps) => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    t("preparingScreen.stepAnalyzing"),
    t("preparingScreen.stepFiltering"),
    t("preparingScreen.stepComparing"),
    t("preparingScreen.stepPersonalizing"),
    t("preparingScreen.stepCustomized", { userFirstName }),
  ];

  useEffect(() => {
    const timeouts: NodeJS.Timeout[] = [];

    timeouts.push(setTimeout(() => setCurrentStep(1), durationMs));
    timeouts.push(setTimeout(() => setCurrentStep(2), durationMs * 2));
    timeouts.push(setTimeout(() => setCurrentStep(3), durationMs * 3));
    timeouts.push(setTimeout(() => setCurrentStep(4), durationMs * 4));

    return () => {
      timeouts.forEach((timeout) => clearTimeout(timeout));
    };
  }, [durationMs]);

  return (
    <PersonalisationScreenLayout contentClassName="flex h-full items-center justify-center p-8">
      <div
        key={currentStep}
        className="duration-500 ease-out animate-in fade-in slide-in-from-bottom-2"
      >
        <PersonalisationHeading size="sm" className="text-center">
          {steps[currentStep]}
        </PersonalisationHeading>
      </div>
    </PersonalisationScreenLayout>
  );
};
